import React from "react";
import _ from "lodash";

const FieldWrapper = (props) => {
  return (
    <div
      className={`field-wrapper mb-4 ${
        props.twoColumnLayout ? "grid sm:grid-cols-3 items-start gap-x-6" : ""
      } ${props.wrapperCss ?? ""}`}
    >
      <label
        className={`text-mobileS md:text-desktopS font-bold block mb-1 ${
          props.twoColumnLayout ? "mt-3 sm:col-span-1" : ""
        }`}
      >
        {props.label}
      </label>

      <div className={`${props.twoColumnLayout ? "sm:col-span-2" : ""}`}>
        {props.children}

        {_.isString(props.error) && (
          <div className="form-error text-red-500 text-desktopXS mt-2">
            {props.error}
          </div>
        )}
      </div>
    </div>
  );
};

export default FieldWrapper;
